import axios from "axios";

class WordPressService {
  constructor() {
    this.baseURL = "https://public-api.wordpress.com/rest/v1.1/sites/selectairintranet.wpcomstaging.com";
    this.axiosInstance = axios.create({
      baseURL: this.baseURL,
    });
  }

  /**
   * Fetch a specific post by ID from WordPress API
   * @param {string|number} postId - The post ID to fetch
   * @returns {Promise<Object>} The post data
   */
  async getPost(postId) {
    try {
      const response = await this.axiosInstance.get(`/posts/${postId}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching WordPress post:', error);
      throw error;
    }
  }

  /**
   * Extract category names from WordPress post data
   * @param {Object} post - The WordPress post object
   * @returns {Array<string>} Array of category names
   */
  getCategoryNames(post) {
    if (!post.categories) {
      return [];
    }
    
    return Object.keys(post.categories).map(categoryKey => {
      return post.categories[categoryKey].name;
    });
  }

  /**
   * Extract the first category name from WordPress post data
   * @param {Object} post - The WordPress post object
   * @returns {string} The first category name or empty string
   */
  getFirstCategoryName(post) {
    const categories = this.getCategoryNames(post);
    return categories.length > 0 ? categories[0] : '';
  }

  /**
   * Format HTML content for display
   * @param {string} htmlContent - Raw HTML content from WordPress
   * @returns {string} Formatted HTML content
   */
  formatContent(htmlContent) {
    // Return the HTML content as-is since we'll render it using v-html
    // You can add additional formatting here if needed
    return htmlContent;
  }
}

export default new WordPressService();
